/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_MergeInputs */

const en_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge`)
};

const fr_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner`)
};

const de_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschmelzen`)
};

const it_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci`)
};

const ru_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние`)
};

const es_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unir`)
};

const zh_cn2_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并`)
};

const ja_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージ`)
};

const hi_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मर्ज`)
};

const pt_pt2_context_menu_merge = /** @type {(inputs: Context_Menu_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão`)
};

/**
* | output |
* | --- |
* | "Merge" |
*
* @param {Context_Menu_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_merge = /** @type {((inputs?: Context_Menu_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_merge(inputs)
	if (locale === "de") return de_context_menu_merge(inputs)
	if (locale === "it") return it_context_menu_merge(inputs)
	if (locale === "ru") return ru_context_menu_merge(inputs)
	if (locale === "es") return es_context_menu_merge(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_merge(inputs)
	if (locale === "ja") return ja_context_menu_merge(inputs)
	if (locale === "hi") return hi_context_menu_merge(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_merge(inputs)
	return en_context_menu_merge(inputs)
});